import { CombinedError } from 'urql';

export const checkPermisions = (error: CombinedError | undefined): boolean => {
    if (error === undefined) {
        return true;
    }

    for (const errorCodes of error.graphQLErrors) {
        const errorUserCode = errorCodes.extensions.userCode;
        if (errorUserCode === 'blog-article-access-denied') {
            return false;
        }
    }

    return true;
};
